import { writable } from 'svelte/store';
import { browser } from '$app/environment';
import { api } from '$lib/utils/api.js';

export const hasUnread = writable(false);

let inflight = null;

export async function checkUnread() {
	if (!browser) return;
	if (inflight) return inflight;
	inflight = api.get('/api/announcements/unread-check/');
	try {
		const result = await inflight;
		if (result?.ok && result.data?.data) {
			hasUnread.set(!!result.data.data.has_unread);
		}
	} finally {
		inflight = null;
	}
}

export async function markRead() {
	if (!browser) return;
	const result = await api.post('/api/announcements/mark-read/');
	if (result?.ok) {
		hasUnread.set(false);
	}
}
